import React, {FunctionComponent, memo, ReactNode, useEffect, useState} from 'react'
import {getCookieValue} from "@/utils/Mobile/utils";

interface Props {
    children?: ReactNode;
    resourceName: string;
    resources: { [key: string]: { enabledLevels: string } };
}

const LoadingProgressiveResource: FunctionComponent<Props> = memo((props) => {
    const [userLevel, setUserLevel] = useState('');

    useEffect(() => {
        let userLevelCookie = getCookieValue('user-level')
        if (userLevelCookie && ['1', '2', '3'].includes(userLevelCookie)) {
            setUserLevel('Level' + userLevelCookie)
        } else {
            setUserLevel('Level3')
        }
    }, [])
    const {children, resourceName, resources} = props
    if (resources[resourceName]) {
        if (resources[resourceName].enabledLevels.split(',').includes(userLevel)) {
            return (
                <>
                    {children}
                </>
            )
        }
        return null;
    } else {
        return (
            <>
                {children}
            </>
        )
    }

})
export default LoadingProgressiveResource